import React from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchVideoJobStatusSelector from "selectors/fetchVideoJobStatus";
import videoJobSelector from "selectors/videoJob";
import ReviewAnimationDataSection from "./ReviewAnimationDataSection";
import ReviewAnimationLoadingSection from "./ReviewAnimationLoadingSection";
import styles from "./ReviewAnimationVideoJobRouter.module.scss";

interface Props {
    videoJobId: string;
}

const ReviewAnimationVideoJobRouter: React.FC<Props> = ({ videoJobId }) => {
    const dispatch = useDispatch();
    const videoJob = useSelector(videoJobSelector);
    const fetchVideoJobStatus = useSelector(fetchVideoJobStatusSelector);

    React.useEffect(() => {
        if (
            fetchVideoJobStatus === "none" &&
            (!videoJob || !videoJob.rendahand_file_data)
        ) {
            const interval = setInterval(() => {
                dispatch({
                    type: "com.sage.actions.createAnimation.IFetchVideoJob",
                    videoJobId,
                } as sage.actions.createAnimation.IFetchVideoJob);
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [videoJob, fetchVideoJobStatus, videoJobId, dispatch]);

    return (
        <div className={styles.outer}>
            {videoJob && videoJob.rendahand_file_data ? (
                <ReviewAnimationDataSection videoJob={videoJob} />
            ) : (
                <ReviewAnimationLoadingSection />
            )}
        </div>
    );
};

export default ReviewAnimationVideoJobRouter;
